<template>
  <v-dialog v-model="dialog" persistent max-width="600" :lazy="true">
    <v-card v-if="notification">
      <v-card-title>
        <div>
          <span class="headline">System Notification</span><br/>
          <span class="grey--text">{{formateDateTime(notification.createdDate)}}</span><br/>
        </div>
      </v-card-title>
      <v-card-text>{{notification.defMsg}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click.native="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDisplayDateTime } from '@/utils/date'
export default {
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    'value': function (value) {
      this.dialog = value
    },
    'dialog': function (value) {
      if (!value) {
        // As this components using v-model to pass in value,
        // we have to emit back the value
        this.$emit('input', false)
      }
    }
  },
  methods: {
    formateDateTime(time) {
      return formatDisplayDateTime(time)
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    notification: {
      type: Object,
      default: () => { }
    }
  }
}
</script>

<style>

</style>
